import { isMobile } from '../../utils/utils';

const initialState = {
  clientDetails: {
    isUpload: isMobile ? false : true,
    disableNameFields: false,
    skipOcr: false,
    customerHouseImg: false,
    idCustomerHouseImg: '',
    activationErrorMessage: '',
  },
  orderStatus: {},
  finalStatus: {},
  location: [],
  permissionError: false,
  coverageLocation: { lat: null, lng: null },
  crosselling: {
    isCrosselling: false,
    serviceProfileSelected: null,
    servicesProfile: [],
  }
};

export const activation = {
  state: { ...initialState },
  reducers: {
    updateClientInformation(state, payload) {
      return {
        ...state,
        clientDetails: { ...state.clientDetails, ...payload },
      };
    },
    clearActivation() {
      return { ...initialState };
    },
    import(state, payload) {
      return { ...state, ...payload };
    },
    setDisabledStatus(state, payload) {
      return {
        ...state,
        clientDetails: { ...state.clientDetails, disableNameFields: payload },
      };
    },
    resetInputAddress(state) {
      return {
        ...state,
        clientDetails: {
          ...state.clientDetails,
          state: '',
          city: '',
          street: '',
          streetNumber: '',
          betweenStreet: '',
          neighborhood: '',
          area: '',
          tower: '',
          block: '',
          floor: '',
          department: '',
          addressref: '',
          states: [],
          neighborhoods: [],
          addresses: [],
          areas: [],
          cities: [],
        },
      };
    },
    updateLocation(state, payload) {
      return {
        ...state,
        location: payload,
      };
    },
    updateCoverageLocation(state, payload) {
      return {
        ...state,
        coverageLocation: payload,
      };
    },
    setPermissionStatus(state, payload) {
      return {
        ...state,
        permissionError: payload,
      };
    },
    updateCrosselling(state, payload) {
      return {
        ...state,
        crosselling: { ...state.crosselling, ...payload },
      };
    },
    clearCrosselling(state) {
      return {
        ...state,
        crosselling: {
          isCrosselling: false,
          serviceProfileSelected: null,
        },
      };
    }
  },
  effects: (dispatch) => {
    return {};
  },
};
